import lodash from 'lodash';
import moment from 'moment';


export function getExpirationDateFromDocument(document, descriptorIds) {
    if (descriptorIds.length === 0) {
        return null;
    }

    const docTypeName = lodash.toLower(document.documentType.displayName);
    if (docTypeName.includes('archived') || docTypeName.includes('expir') || docTypeName.includes('obsolete')) {
        return null;
    }

    let expiration = lodash.find(document.descriptors, (descriptor) => { return lodash.indexOf(descriptorIds, descriptor.id) !== -1; });
    if (lodash.isNil(expiration)) {
        expiration = null;
    } else {
        const expirationDateArray = lodash.get(expiration, 'values', []);
        const expirationDate = moment(expirationDateArray[0]);
        expiration = expirationDate.isValid() ? expirationDate : null;
    }
    return expiration;
}
